export const markdown_faq_38_1 = `
L'accesso ad INBEE avviene con due fattori di autenticazione: password utente e codice di sicurezza OTP ricavabile dal proprio dispositivo mobile. Il codice di sicurezza del tuo profilo INBEE può essere trasmesso a più cellulari, a patto che vengano preventivamente associati. In questo video ti mostreremo la procedura per configurare ulteriori dispositivi, oltre al primo già associato, per l'accesso al tuo profilo INBEE.

La generazione del codice di sicurezza OTP viene effettuata da specifiche App di Autenticazione. Come prima cosa è quindi necessario scaricare l'app di Autenticazione sul dispositivo, noi consigliamo Microsoft Authenticator, ma sono idonee anche altre applicazioni.
`;

export const markdown_faq_38_2 = `
Successivamente, inserire il codice di configurazione che hai ottenuto in fase di configurazione del primo dispositivo. Può essere un codice numerico o un QRCode.
Dovrai quindi recuperare tale codice precedentemente salvato e inserirlo nell'app di autenticazione sul nuovo dispositivo. 

1. Seleziona *+*
2. Seleziona *Altro Account*
3. Inquadra il QRCode o inserisci il codice alfanumerico di configurazione
`;

export const markdown_faq_38_3 = `
In questo modo anche il nuovo dispositivo sarà associato alla tua untenza Inbee e potrai utilizzarlo per l'ottenimento dei codici di sicurezza.
`;
